(() => {
  const initialize = (scope = document) => {
    scope.querySelectorAll('[data-product-section]').forEach((section) => {
      if (section.dataset.galleryReady) return;
      section.dataset.galleryReady = 'true';
      const thumbnails = [...section.querySelectorAll('[data-product-thumbnail]')];
      const slides = [...section.querySelectorAll('[data-product-slide]')];
      const status = section.querySelector('[data-product-gallery-status]');
      if (!thumbnails.length) return;

      const select = (thumbnail, announce = true) => {
        const selected = slides.find((slide) => slide.dataset.productSlide === thumbnail.dataset.productThumbnail);
        if (!selected) return;
        slides.forEach((slide) => {
          if (slide === selected) return;
          slide.querySelectorAll('video').forEach((video) => video.pause());
          // Reload only a previously visible external player so hidden media stops playing.
          if (!slide.hidden) slide.querySelectorAll('iframe').forEach((frame) => {
            const source = frame.getAttribute('src');
            if (source) frame.setAttribute('src', source);
          });
          slide.hidden = true;
        });
        selected.hidden = false;
        thumbnails.forEach((item) => {
          if (item === thumbnail) item.setAttribute('aria-current', 'true');
          else item.removeAttribute('aria-current');
        });
        if (announce && status) status.textContent = thumbnail.getAttribute('aria-label').replace(/^Show /, 'Showing ');
      };

      thumbnails.forEach((thumbnail, index) => {
        thumbnail.addEventListener('click', (event) => {
          // Modified clicks retain the image link's normal open-in-new-tab behavior.
          if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          event.preventDefault();
          select(thumbnail);
        });
        thumbnail.addEventListener('keydown', (event) => {
          let targetIndex;
          if (event.key === 'ArrowRight') targetIndex = (index + 1) % thumbnails.length;
          else if (event.key === 'ArrowLeft') targetIndex = (index - 1 + thumbnails.length) % thumbnails.length;
          else if (event.key === 'Home') targetIndex = 0;
          else if (event.key === 'End') targetIndex = thumbnails.length - 1;
          else return;
          event.preventDefault();
          const target = thumbnails[targetIndex];
          target.focus({ preventScroll: true });
          target.scrollIntoView({ behavior: 'instant', block: 'nearest', inline: 'nearest' });
          select(target);
        });
      });
      select(thumbnails.find((thumbnail) => thumbnail.getAttribute('aria-current') === 'true') || thumbnails[0], false);
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize());
  else initialize();
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  document.addEventListener('shopify:block:select', (event) => {
    const details = event.target.closest('.hp-accordion');
    if (details) details.open = true;
  });
})();
